module.exports = __webpack_public_path__ + "static/media/bfile-life-stage-5.d3d72401.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bfile-life-stage-5.png
// module id = 2670
// module chunks = 0